import styled, { css } from 'styled-components';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const Divider = styled.hr`
  border: 1px solid ${nuDSColor('black', 'defaultT20')};
  margin: ${spacing('8x')} 0;
  width: 100%;

  ${breakpointsMedia({
    md: css`
      margin: ${spacing('16x')} 0;
    `,
  })}
`;

Divider.displayName = 'Divider';

export const StyledTypographyChannelHeading = styled(Typography)`
  display: none;

  ${breakpointsMedia({
    md: css`
      display: block;
    `,
  })}
`;

StyledTypographyChannelHeading.displayName = 'StyledTypographyChannelHeading';

export const StyledTypographyChannelSubtitle = styled(Typography)`

  ${breakpointsMedia({
    md: css`
      min-height: 3rem;
    `,
  })}
`;

StyledTypographyChannelSubtitle.displayName = 'StyledTypographyChannelSubtitle';

export const Channel = styled.div`
  flex: 1;
`;

Channel.displayName = 'Channel';

export const Channels = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${Channel} + ${Channel} {
    margin-top: ${spacing('8x')};
  }

  ${breakpointsMedia({
    md: css`
      flex-direction: row;
      justify-content: space-between;

      ${Channel} + ${Channel} {
        margin-top: 0;
        margin-left: ${spacing('8x')};
      }
    `,
  })}
`;

Channels.displayName = 'Channels';
